export class LegacyClientPageRenderer {};
